import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RegisterService {

    constructor(
        private http: HttpClient,
        private router: Router
    ) { }

    register(data: any, captchaResponse: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'g-recaptcha-response': captchaResponse
            })
        };
        const url = `${environment.api}/register`;
        return this.http.post<Observable<any>>(url, data, httpOptions);
    }

    confirm(token: any): Observable<any> {
        let params = new HttpParams();
        params = params.set('token', token);
        const url = `${environment.api}/register/confirm`;
        return this.http.post<Observable<any>>(url, {}, { params });
    }

    resetToken(email: any): Observable<any> {
        let params = new HttpParams();
        params = params.set('email', email);
        const url = `${environment.api}/register/resent_token`;
        return this.http.post<Observable<any>>(url, {}, { params });
    }
}